import styled from "@emotion/styled";
import { FC } from "react";
import { Field } from "react-final-form";

import { FormField, Input } from "@livechat/design-system-react-components";

import { useBreakpoints } from "hooks/use-breakpoints";
import { useTaxDetails } from "routes/subscription/contexts/tax-details-context";
import { compose, maxLength, required } from "utils/validators";

import {
  getCardFormFieldError,
  hasCardFormFieldError,
  recurlyApiErrorFormFieldNames,
  requiredCardFormFieldsErrors,
} from "./helpers";

export const PostalCodeInputField: FC = () => {
  const { setZipCode } = useTaxDetails();
  const { isMobile } = useBreakpoints();

  return (
    <Field
      name="postal_code"
      validate={compose(
        required(requiredCardFormFieldsErrors.postal_code),
        maxLength(`${recurlyApiErrorFormFieldNames.postal_code} is too long (20 characters)`, 20)
      )}
      render={({ input, meta }) => (
        <HalfWidthFormField labelText="ZIP / Postal Code" labelFor={input.name} error={getCardFormFieldError(meta)}>
          <Input
            {...input}
            value={input.value as string}
            id={input.name}
            inputSize={isMobile ? "large" : "medium"}
            data-1p-ignore
            autoComplete="off"
            error={hasCardFormFieldError(meta)}
            onChange={e => {
              setZipCode(e.target.value);
              input.onChange(e);
            }}
          />
        </HalfWidthFormField>
      )}
    />
  );
};

const HalfWidthFormField = styled(FormField)`
  width: 50%;
`;
